import { logoutEventDispatch } from '@space-lib-events/logout'
import { renewTokenEventDispatch } from '@space-lib-events/renewToken'
import { HttpCodes } from '@space-lib/constants'
import { MonitoringUtils } from '@space-shell/common/utils/monitoring'
import type { AxiosError } from 'axios'

import ApiError from './error'
import type { ResponseError } from './types'

import { EXPIRED_TOKEN_MESSAGES } from '../../constants'

const handleApiError = (error: AxiosError<ResponseError>) => {
  if (error.response) {
    if (error.response.status === HttpCodes.UNAUTHORIZED) {
      const errorMessage = error.response?.data?.message || error.message || 'No error message'

      MonitoringUtils.trace({ message: `[AUTH] 401 - Unauthorized: ${errorMessage}` })

      const shouldTryToRenewToken = EXPIRED_TOKEN_MESSAGES.some((message) =>
        errorMessage.includes(message)
      )

      if (shouldTryToRenewToken) {
        renewTokenEventDispatch()

        return
      }

      logoutEventDispatch({
        origin: error.request.responseURL ?? '',
        message: errorMessage
      })
    }

    const responseError = new ApiError({
      statusCode: error.response.status,
      code: error.response.data.code,
      message: error.response.data.message,
      headers: error.response.headers,
      extra: error.response.data.extra
    })

    return Promise.reject(responseError)
  }

  if (error.request) {
    const requestError = new ApiError({
      statusCode: Number(error.code),
      message: String(error.request)
    })

    return Promise.reject(requestError)
  }

  const genericError = new ApiError({ statusCode: 500, message: error.message })

  return Promise.reject(genericError)
}

export const whenRequestWithError = (error: AxiosError<ResponseError>) => {
  return handleApiError(error)
}

export const whenResponseWithError = (error: AxiosError<ResponseError>) => {
  return handleApiError(error)
}
